import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const getProductsFunc = createAsyncThunk(
    "getAllProducts",
    async (query = '', thunkAPI) => {
        try {
            const res = await api.get(`dashboard/products${query}`);
            return res.data.data.products;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
)

const getProductsSlicer = createSlice({
    name: "getAllProducts",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducer: {},
    extraReducers: (builder) => {
        builder.addCase(getProductsFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
            .addCase(getProductsFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";

            })
            .addCase(getProductsFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
})

export default getProductsSlicer.reducer;